/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import gql from "graphql-tag";
import get from "lodash/get";
import { useQuery } from "@apollo/react-hooks";

import _str from "shared/util/_str";
import Strf from "shared/components/Strf";
import OkPhotos from "legacy/okphotos/okphotos.js";

const GET_PHOTO_COUNT_QUERY = gql`
	query getPhotoCountQuery($userid: String!) {
		user(id: $userid) {
			id
			photos { id }
		}
	}
`;

const OkPhotoUploader = ({ userid }) => {
	const { data } = useQuery(GET_PHOTO_COUNT_QUERY, {
		variables: {
			userid,
		},
	});

	useEffect(() => {
		OkPhotos.initialize({ userid });
	}, [userid]);

	useEffect(() => {
		if (!data) {
			return;
		}

		const numPhotos = get(data, "user.photos", []).length;
		OkPhotos.setPhotoCount(numPhotos);
	}, [data]);

	return userid && (
		<div id="okphotos_overlay">
			<div className="content">
				<div id="okphotos_action_area">
					<div id="okphotos_upload" className="action">
						<div className="action_content">
							<h3 className="title">{_str("Where’s your photo?")}</h3>
							<div id="service_picker">
								<div className="picker_wrapper">
									<div className="services">
										<a id="service_facebook" className="service" href="javascript:void(0)">
											<i className="icon i-facebook-inverted" />
											<div className="label">{_str("Facebook")}</div>
										</a>

										<form id="okphotos_upload_form" action="/ajaxuploader" method="POST">
											<label id="service_computer" className="service" htmlFor="okphotos_file_input">
												<i className="icon i-pc" />
												<div className="label">
													<span className="pc_only">{_str("My PC")}</span>
													<span className="mac_only">{_str("My Mac")}</span>
												</div>
											</label>
											<input type="file" id="okphotos_file_input" name="file" accept="image/*" />
											<input type="hidden" name="userid" value={userid} />
											<input type="hidden" name="simple_ajax" value="1" />
										</form>

										<a id="service_instagram" className="service" href="javascript:void(0)">
											<i className="icon i-instagram" />
											<div className="label">{_str("Instagram")}</div>
										</a>
									</div>

									<div id="iframe_container" />
								</div>

								<p className="dragndrop_message">
									{_str("Drop it like it’s hot")}
								</p>
								<div id="okphotos_dragndrop" />
							</div>

							<div id="okphotos_rules" className="user_tips">
								<span className="rules-profile-photos">
									{_str("Photos need to be larger than 400x400px and you need to be in the photo. Also, no naughty bits!")}
								</span>
								<span className="rules-more-photos">
									<Strf vars={{ $br: <br /> }}>
										Photos need to be larger than 400x400px$br and must be of you or taken by you.
										Also, no naughty bits!
									</Strf>
								</span>
							</div>
						</div>
					</div>

					<div id="okphotos_photo_tiles" className="action">
						<div id="photo_tiles_header" className="action_header">
							<div className="title" href="javascript:void(0)" />
							<a className="subtitle" href="javascript:void(0)" />
						</div>

						<div className="action_content has_header has_footer">
							<div id="photo_tile_holder" className="tile_holder" />

							<div id="photo_subtile_holder" className="tile_holder" />

							<div id="photo_tiles_loader">
								<div className="icon" />
							</div>
						</div>

						<div className="action_footer">
							<button id="photo_tiles_done" className="flatbutton green disabled">{_str("Next")}</button>
						</div>
					</div>

					<div id="okphotos_edit" className="action">
						<div className="action_header">
							<div className="crop_header">
								<div className="title">{_str("Edit thumbnail")}</div>
							</div>
							<div className="caption_header">
								<div className="title">{_str("Add a caption")}</div>
							</div>
						</div>

						<div className="action_content has_header has_footer">
							<div id="okphotos_edit_wrapper">
								<img id="okphotos_photo" />
							</div>
						</div>

						<div id="okphotos_edit_actions" className="action_footer okform">
							<textarea id="photo_caption" placeholder={_str("Say something about your photo (optional)")} maxLength="100" />
							<a id="okphotos_edit_next" className="flatbutton green">{_str("Done")}</a>
						</div>
					</div>

					<div id="okphotos_finished" className="action">
						<div className="content">
							<div className="action_content">
								<div className="reassurance">{_str("You look great")}!</div>
								<img id="okphotos_cropped_photo" />

								<button id="upload_another" className="flatbutton blue">
									{_str("Add more")}
								</button>
								<a href="javascript:;" id="done_uploading">
									{_str("I’m Done")}
								</a>
							</div>
						</div>
					</div>

					<div id="okphotos_error" className="action">
						<div className="action_content">
							<div className="content">
								<div className="container">
									<div className="error_icon">
										<i className="icon i-alert" />
									</div>
									<div className="message" />
									<button className="flatbutton white">{_str("Try again")}</button>
								</div>
							</div>
						</div>
					</div>

					<a id="okphotos_action_close" href="javascript:void(0)">
						<i className="icon i-close" />
					</a>
				</div>
			</div>
		</div>
	);
};

OkPhotoUploader.propTypes = {
	userid: PropTypes.string.isRequired,
};

export default OkPhotoUploader;



// WEBPACK FOOTER //
// ./src/shared/components/OkPhotoUploader.jsx